import { Search, Handshake, Hammer, Building2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

const icons = [Search, Handshake, Hammer, Building2];

export const WhatWeDo = () => {
  const { t } = useLang();
  return (
    <section
      id="what-we-do"
      data-testid="what-we-do-section"
      className="scroll-mt-24 bg-[#EAE8E3] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-6">
            {t.whatWeDo.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#1A1C19] max-w-2xl">
            {t.whatWeDo.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-stone-300/60 border border-stone-300/60">
          {t.whatWeDo.cards.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group h-full bg-[#F4F3EF] p-8 md:p-10 hover:bg-white transition-colors duration-500"
                >
                  <span className="font-serif text-sm text-[#B5A68B]">
                    0{i + 1}
                  </span>
                  <Icon
                    className="mt-6 text-[#3A4036] group-hover:text-[#1A1C19] transition-colors"
                    size={28}
                    strokeWidth={1.4}
                  />
                  <h3 className="mt-6 font-serif text-xl md:text-2xl text-[#1A1C19] leading-snug">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-sm md:text-base leading-relaxed text-[#5C5C59]">
                    {s.copy}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
